import { render, staticRenderFns } from "./CreateUAMUserModal.vue?vue&type=template&id=112f445e&scoped=true"
import script from "./CreateUAMUserModal.vue?vue&type=script&lang=js"
export * from "./CreateUAMUserModal.vue?vue&type=script&lang=js"
import style0 from "./CreateUAMUserModal.vue?vue&type=style&index=0&id=112f445e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f445e",
  null
  
)

export default component.exports